// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__9dw1_","box":"styles_box__BPnWl","icon":"styles_icon__D1CNb"};